import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IHealthInsuranceFundCache } from 'gen/ApiClient';
import React from 'react';

export const HealthInsuranceFundsCacheContext = React.createContext<IPreloadCacheContext<IHealthInsuranceFundCache>>(undefined as any);
